<template>
  <div>
    <!--头部导航-->
    <div class="head-wrap">
        <div class="navigation">
            <div class="logo" @click="$router.push('/')">
                <img :src="!_IsDevMode?'/images/public/guide_logo.png':'/images/public/guide_logo_1.png'"/>
            </div>
            <div v-if="category==1" class="loginSwitch" >
                您是企业用户？<span class=" cursor-pointer text-primary font-weight-bold" @click="$router.push({name:'enterpriseLogin'})">登录企业后台 <i class="el-icon-arrow-right"></i></span>
            </div>
            <div v-if="category==2" class="loginSwitch" >
                您是个人用户？<span class=" cursor-pointer text-primary font-weight-bold" @click="$router.push('/')">订单雨首页 <i class="el-icon-arrow-right"></i></span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    category: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
    .head-wrap{
        z-index: 999;
        height: 80px;
        overflow: hidden;
        width: 100%;
        display: flex;
        margin: 0 auto;
        justify-content: space-around;
        background-color: #fff;
        --tw-shadow: 0 15px 15px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        -webkit-box-shadow: var(--tw-shadow);
        box-shadow: var(--tw-shadow);
    }
    .navigation{
        width: 1200px;
        min-width: 1200px;
        height: 80px;
        display: flex;
        justify-content: space-between;
    }
    .head-wrap img{
        width: 180px;
        height: 61px;
        margin-right: 60px;
        float: left;
    }
    .head-wrap .logo{
        display: flex;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
    }
    .loginSwitch{
      float: right;
      line-height: 80px;
    }
</style>
